module.exports = __webpack_public_path__ + "static/media/external-users-welcome-graphic.994493a3.png";